import { loadStripe } from "@stripe/stripe-js";

// function to export stripeInstance
// due to promise we would need this helper to make sure latest value is returned
export const Stripe = (() => {
  let stripeInstance = null;
  return async () => {
    try {
      if (!stripeInstance) {
        stripeInstance = await loadStripe(process.env.VUE_APP_STRIPE_KEY);
      }

      return stripeInstance;
    } catch (e) {
      console.error("Stripe initialization error", e);
    }
  };
})();

export const isPrepaidCard = funding => funding === "prepaid";
